<div id="wistia_{{wistiaCode}}" aria-live="assertive" class="w-100 wistia_embed wistia_async_{{wistiaCode}}" style="height: 480px;">&nbsp;</div>
@if (isModal) {
  <div class="w-100 d-flex justify-content-center my-2">
    <button id="wistiaModalCloseButton" class="text-center btn btn-outline-tertiary" (click)="dismiss()">Close Video</button>
  </div>
}